import {useEffect, useState} from 'react';
import {useParams} from "react-router";
import {Card, Popover} from 'antd';
import {getPlantsByGenetics} from "../../api/Api";
import {BasicPlantTable} from "./BasicPlantTable";
import {WholesaleProductsCard} from "./WholesaleProductsCard";

export const GeneticView = ({refresh, onRefresh, onApiFail, props}) => {
    const params = useParams();
    const {geneticId} = params;

    const [plants, setPlants] = useState([]);

    useEffect(() => {
        if (geneticId === undefined) {
            // no plant set yet
            return;
        }

        getPlantsByGenetics(geneticId).then(r => {
            setPlants(r.map(plant => {
                return {...plant, key: plant.id}
            }))
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [geneticId, refresh, onApiFail]);

    const divStyle = {
        textAlign: 'left'
    }
    return <div style={divStyle}>
        <Card title={<b><Popover content={'Plants can be traced to a common ancestor'}>Genetically Similar Plants</Popover></b>}>
            <BasicPlantTable plants={plants} showGeneration={false} />
        </Card>
        <WholesaleProductsCard geneticId={geneticId} onApiFail={onApiFail} onRefresh={onRefresh} refresh={refresh} />
    </div>

    // <Card title={<b><Popover content={'Wholesale Products Generated During Harvest'}>Wholesale Products</Popover></b>}>
    // </Card>
}